"use script";

const notAllowed = [
  "vermont",
  "washington",
  "rhode island",
  "puerto rico",
  "new york",
  "new jersey",
  "maine",
  "hawaii",
  "connecticut",
  "california",
  "arizona",
  "alaska",
];

document.addEventListener("DOMContentLoaded", function () {
  const stateSelector = document.querySelector("#state-selector-custom");
  let destination = stateSelector?.value;

  // purchase btns
  const addToCartBtn = document.querySelector(
    'button[data-add-to-cart-text="Add to cart"][name="add"]'
  );

  const buyBtnContainer = document.querySelector(".shopify-payment-button");

  const enableAddCartBtn = (enabled) => {
    if (addToCartBtn) {
      if (enabled) {
        addToCartBtn.classList.remove("disabled-element");
      }
      if (!enabled) {
        addToCartBtn.classList.add("disabled-element");
      }
    }
  };

  const enableBuyBtn = (enabled) => {
    if (buyBtnContainer) {
      if (enabled) {
        buyBtnContainer.style.display = "block";
      }
      if (!enabled) {
        buyBtnContainer.style.display = "none";
      }
    }
  };

  const handleBtns = (destination) => {
    if (destination) {
      if (notAllowed.includes(destination)) {
        enableAddCartBtn(false);
        enableBuyBtn(false);
      } else {
        enableAddCartBtn(true);
        enableBuyBtn(true);
      }
    } else {
      enableAddCartBtn(false);
      enableBuyBtn(false);
    }
  };

  handleBtns(destination);

  stateSelector.addEventListener("change", () => {
    destination = stateSelector.value;

    handleBtns(destination);
  });

  addToCartBtn.addEventListener("click", (e) => {
    if (destination === "" || notAllowed.includes(destination)) {
      e.preventDefault();
    }
  });

  window.addEventListener("beforeunload", function (event) {
    stateSelector.value = "";
  });
});
